<template>
    <section class="body-container">
        <div class="content-max-width">
            <div class="cards flex flex-between">
                <a v-for="item in articles" :key="item.id" :href="item.url" class="card">
                    <div class="image">
                        <div class="content">
                            <img :src="item.image" alt="">
                        </div>
                    </div>
                    <div class="content">
                        <h3>{{ item.title }}</h3>
                        <p>{{ item.published_date }}</p>
                        <p class="read-more">Read More</p>
                    </div>
                </a>
            </div>            
            <button v-if="next" type="button" class="load-more button" @click="loadMore">Load More +</button>
        </div>
    </section>
</template>

<script>
export default {
  props: [
    "url"
  ],

  data () {
    return {
      links: [],
      articles: [],
      next: ""
    }
  },

  mounted(){
      axios.get(this.url).then(response => {
        this.articles = response.data.data
        this.next = response.data.links.next
      })
  },

  methods: {
    loadMore () {
      axios.get(this.next).then(response => {
        this.articles = this.articles.concat(response.data.data)
        this.next = response.data.links.next
      })
    },
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/frontend/js/components/News.vue